import type React from 'react';
import Translation from '../../../../../general/Translation/Translation';
import Badge from '../../../../../general/Badge/Badge';
import DeadLineModal from '../DeadlineModal/DeadLineModal';

export interface DiscountPriceProps {
  discountPercentage: number;
  isSoldOut: boolean;
  price: string;
  priceFrom: string;
  productId: number;
  shippingCostsText: string;
  siteUrl: string;
}

export const DiscountPrice: React.FC<DiscountPriceProps> = ({
  discountPercentage,
  isSoldOut,
  price,
  priceFrom,
  productId,
  shippingCostsText,
  siteUrl,
}) => (
  <>
    <div>
      <Translation
        pageString="productinformatie"
        stringId="of"
      />{' '}
      <del>{priceFrom}</del>
    </div>

    <div className="article-price">
      <div className="article-price__total article-price__total--primary02">
        {price}
        <Badge
          customClassNames="bold ml-2"
          colorScheme="primary02"
        >
          {`-${discountPercentage}%`}
        </Badge>
      </div>

      {!isSoldOut && (
        <DeadLineModal
          productId={productId}
          shippingCostsText={shippingCostsText}
          siteUrl={siteUrl}
        />
      )}
    </div>
  </>
);
